import React from "react";
import PasswordActionForm from "./PasswordActionForm";

const Reset = () => <PasswordActionForm mode="reset" />;

export default Reset;
